export const Column = [
  {
    Header: 'Date',
    accessor: 'date',

    disableFilters: true,
  },
  {
    Header: 'Trx Type',
    accessor: 'transaction_type',
  },
  {
    Header: 'Amount',
    accessor: 'amount',
  },
  {
    Header: 'Total',
    accessor: 'total',
  },
  {
    Header: 'Payment',
    accessor: 'payment',
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Action',
    accessor: 'action',

    disableSorting: true,
  },
];
